import {
  getPaymentInfo,
  initPayment,
  getPlanInfo,
  getPlanCmsDetail,
  getQuotation,
} from './service';

export default {
  namespace: 'payment',
  state: {
    planInfo: {},
    planCmsInfo: {},
    quotationInfo: {},
  },
  reducers: {
    setData(state: PaymentState, { payload }: PayloadType) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    *getPlanInfo({ payload }: PayloadType, { put, call, select }: any): any {
      const planInfo = yield call(getPlanInfo, payload);
      yield put({
        type: 'setData',
        payload: { planInfo },
      });
    },
    *getPlanCmsDetail(
      { payload }: PayloadType,
      { put, call, select }: any,
    ): any {
      const planCmsInfo = yield call(getPlanCmsDetail, payload);
      yield put({
        type: 'setData',
        payload: { planCmsInfo },
      });
    },
    *getQuotation({ payload }: PayloadType, { put, call, select }: any): any {
      const res = yield call(getQuotation, payload);
      const quotationInfo = res.quote;
      yield put({
        type: 'setData',
        payload: { quotationInfo },
      });
    },
    *payNow({ payload }: PayloadType, { put, call, select }: any): any {
      const { exceptionCallback, productType, applicationId, params } = payload;
      const paymentInfo = yield call(getPaymentInfo, payload);
      if (paymentInfo?.state === 'succeed') {
        exceptionCallback(paymentInfo?.state);
        return;
      }
      const res = yield call(initPayment, productType, applicationId, {
        ...params,
        cancel_pending_tx: paymentInfo?.state === 'pending',
      });
      const redirectToUrl = res?.redirect_to;
      return redirectToUrl;
    },
  },
};
